import React, { useEffect, useState } from "react";
import { Orders } from "../../models/Orders";
import { BASE_URLS } from "../../config/urls";
import { apiFetch } from "../../utils/api";
import {BtnSpinner} from "../../components/fields/BtnSpinner";

export function AdminOrdersChangeModal({
                                           isOpen,
                                           orders,
                                           onClose,
                                           onSaved,
                                       }: {
    isOpen: boolean;
    orders: Orders[];
    onClose: () => void;
    onSaved?: () => void; // чтобы после сохранения обновить список
}) {
    const [status, setStatus] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [changeable, setChangeable] = useState("");
    const [paymentSite, setPaymentSite] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState<string>("");

    // ESC закрывает
    useEffect(() => {
        if (!isOpen) return;
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [isOpen, onClose]);

    // при открытии — сбрасываем поля
    useEffect(() => {
        if (!isOpen) return;
        setStatus("");
        setPaymentStatus("");
        setChangeable("");
        setPaymentSite("");
        setError("");
        setIsSaving(false);
    }, [isOpen]);

    const submit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (isSaving) return;

        try {
            setIsSaving(true);
            setError("");

            const body = JSON.stringify({
                orders,
                status,
                changeable,
                paymentStatus,
                paymentSite,
            });

            const res = await apiFetch(`${BASE_URLS.api}/admin_change`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body,
            });

            if (!res.ok) {
                const txt = await res.text();
                throw new Error(txt || String(res.status));
            }

            onClose();
            onSaved?.();
        } catch (e: any) {
            console.error(e);
            setError(e?.message || "Не удалось изменить заказы");
            setIsSaving(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="profile-modal-overlay" onMouseDown={onClose}>
            <div className="profile-modal" onMouseDown={(e) => e.stopPropagation()}>
                <div className="profile-modal-head">
                    <div>
                        <div className="profile-modal-title">Изменить выбранные заказы</div>
                        <div className="profile-modal-subtitle">Выбрано: {orders.length}</div>
                    </div>
                    <button className="profile-modal-close" onClick={onClose} aria-label="Закрыть">
                        ✕
                    </button>
                </div>

                <div className="profile-modal-body">
                    <form onSubmit={submit}>
                        <div className="admin_title">Изменить статус</div>
                        <select value={status} onChange={(e) => setStatus(e.target.value)} className="select_admin">
                            <option value="">— не менять —</option>
                            <option value="Доставка на склад">Доставка на склад</option>
                            <option value="Доставлен">Доставлен</option>
                        </select>

                        <div className="admin_title">Изменяемый</div>
                        <select value={changeable} onChange={(e) => setChangeable(e.target.value)} className="select_admin">
                            <option value="">— не менять —</option>
                            <option value="yes">Да</option>
                            <option value="no">Нет</option>
                        </select>

                        <div className="admin_title">Статус оплаты</div>
                        <select
                            value={paymentStatus}
                            onChange={(e) => setPaymentStatus(e.target.value)}
                            className="select_admin"
                        >
                            <option value="">— не менять —</option>
                            <option value="yes">Оплачен</option>
                            <option value="no">Не оплачен</option>
                        </select>

                        <div className="admin_title">Способ оплаты</div>
                        <select value={paymentSite} onChange={(e) => setPaymentSite(e.target.value)} className="select_admin">
                            <option value="">— не менять —</option>
                            <option value="yes">Онлайн</option>
                            <option value="no">Оффлайн</option>
                        </select>

                        {error && <div className="admin-form-error">{error}</div>}

                        <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
                            <button type="button" className="admin-button-secondary" onClick={onClose} disabled={isSaving}>
                                Отмена
                            </button>
                            <button type="submit" className="admin-button-secondary" disabled={isSaving}>
                                {isSaving ? <BtnSpinner/> : "Изменить заказы"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}